import type {
  Response,
  DateTotalActivitiesResponse,
} from '@/lib/apollo/query/getTotalActivitiesByDateForUser/query'
import { parseDate } from '@/utils/date'

import type { TransformedData, TransformedDateTotalActivitiesData } from './types'

export const toTransformedDateTotalActivitiesData = (
  dateTotalActivities: DateTotalActivitiesResponse,
): TransformedDateTotalActivitiesData => ({
  ...dateTotalActivities,
  date: parseDate(dateTotalActivities.date),
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined
    ? undefined
    : response.getTotalActivitiesByDateForUser.map(toTransformedDateTotalActivitiesData)
